import { FontWeight, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    banner: {
      background: 'linear-gradient(239.43deg, #EDC7FC 16.47%, #86D8CB 62.23%, #4181E3 99.83%)',
      boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.24)',
      borderRadius: 12,
      display: 'flex',
      padding: [4, 24, 4, 16],
      gap: 12,
      alignItems: 'center',
      marginBottom: 32,

      [mediaQuery(640)]: {
        marginBottom: '12px',
        padding: [8, 16, 12, 16],
        marginInline: 16,
      },
    },

    image: {
      width: 105,
      height: 76,
      [mediaQuery(640)]: {
        width: 83,
        height: 60,
      },
    },

    textContainerWeb: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      [mediaQuery(640)]: {
        display: 'none',
      },
    },

    textContainerMobile: {
      display: 'none',
      flexDirection: 'column',
      gap: 2,
      [mediaQuery(640)]: {
        display: 'flex',
      },
    },

    mobileText: {
      textDecoration: 'underline',
    },

    button: {
      padding: '4px 8px 4px 8px !important',
      whiteSpace: 'nowrap',
      fontSize: '14px !important',
      lineHeight: '20px !important',
      fontWeight: FontWeight.SemiBold,
      [mediaQuery(640)]: {
        display: 'none',
      },
    },
  },
  {
    name: 'AdmakerBanner',
  },
);

export default useStyles;
